export const REFETCH_SCAN_AND_SCAN_SETTINGS_QUERIES = ["GetScanSettings", "GetScanDetail"];
